/** The linked site's edit page on the admin app. */
export const adminSiteUrl = (bmaSiteId: string): string =>
  `https://admin.inrange.io/site/${encodeURIComponent(bmaSiteId)}/edit`;
